// extracted by mini-css-extract-plugin
module.exports = {"Logos":"styles_Logos__Ivx8W","wrapper":"styles_wrapper__7_K3Q"};